import React, {useState} from 'react';
import PropTypes from 'prop-types'

/* Utils */
import {
    useTheme,
    Box,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderThumb
} from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl';

/* Constants */
const DEFAULT_VALUE = 3;

const FitSelector = ({ onFitChange, options }) => {
    const theme = useTheme()
    const [selectedFit, setSelectedFit] = useState([DEFAULT_VALUE]);

    const handleOnChange = (selectedFitValue) => {
        setSelectedFit(selectedFitValue);

        if (onFitChange) {
            onFitChange(selectedFitValue);
        }
    }

    return (
        <Box>
            {options?.length > 0 &&
            (<>
                <Text {...theme.components.WriteReview.fieldTitle} mt={8}>
                    <FormattedMessage
                        defaultMessage="Actual Fit *"
                        id="pdp_reviews.write.actual.fit"
                    />
                </Text>
                <Box position="relative" width="100%">
                    <RangeSlider defaultValue={[DEFAULT_VALUE]}
                        min={1}
                        max={options.length}
                        step={1}
                        py={3}
                        onChangeEnd={handleOnChange}>
                        <RangeSliderTrack boxSize={'1px'} bg='webTypo.textStrikethrough'>
                            <RangeSliderFilledTrack bg='webTypo.textPrimary' />
                        </RangeSliderTrack>
                        <RangeSliderThumb boxSize={'12px'} index={0} bg='webTypo.textPrimary' />
                    </RangeSlider>
                    <Box display="flex" justifyContent="space-between">
                        {options.map((option, index) => (
                            (index === 0 || index === 2 || index === options.length - 1) && (
                                <Text
                                    key={index}
                                    textStyle={'bodyXsRegular'}
                                >
                                    {option.Label}
                                </Text>
                            )
                        ))}
                    </Box>
                </Box>
            </>)
            }
        </Box>
    );
};

FitSelector.propTypes = {
    onFitChange: PropTypes.func,
    options: PropTypes.array.isRequired
};

export default FitSelector;
